import { store } from '../../../../store.js';

const handleName = (packageName, userCount) =>
  `${packageName} - ${userCount} ${userCount > 1 ? 'Users' : 'User'}`;

const getPrice = (productPackage, discountPercentage) => {
  const { productsConfig } = store.getState().packageSelection;
  let price = productsConfig['blockbrief'].configuration.packages[productPackage].base_price;

  if (discountPercentage) {
    const discountedPrice = price * discountPercentage;
    price = Math.round((price - discountedPrice)* 100) / 100;
  }
  return price;
};

const handleBlockbriefConfig = (quote, quoteConfig, category) => {
  const { headLine: packageName, minimumInitialTerm } = quote;
  const { number_of_users: userCount, package: productPackage } = quoteConfig.configuration;

  let product = {};
  const productList = [];

  // Default Values
  product.item_brand = 'Blockbrief';
  product.item_category = category;
  product.item_variant = packageName;
  product.coupon = null;
  const discountPercentage = quote.provisioningInfo?.discountPercentage
    ? quote.provisioningInfo?.discountPercentage / 100
    : null;

  product.item_id = product.item_name = handleName(packageName, userCount);
  product.price = getPrice(productPackage, discountPercentage);
  product.quantity = minimumInitialTerm;
  product.item_category2 = minimumInitialTerm.toString();
  product.item_category3 = null;

  productList.push({ ...product });
  return productList;
};

export { handleBlockbriefConfig };
